if (!customElements.get('bbbio-kit-purchase')) {
  customElements.define(
    'bbbio-kit-purchase',
    class BbbioKitPurchase extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;

          ['PurchasePrice', 'KitFormat'].forEach((id) => {
            const source = event.data.html.getElementById(`${id}-${this.dataset.section}`);
            const destination = document.getElementById(`${id}-${this.dataset.section}`);

            if (source && destination) destination.innerHTML = source.innerHTML;
          });
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }
    }
  );
}
